<template>
  <div class="box">

    <div class="columns">

      <div class="column is-two-thirds">

        <!-- the new post title -->
        <div class="field">
          <label class="label">Books's title</label>
          <div class="control">
            <input type="text" class="input" placeholder="Title" v-model="title">
          </div>
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <div class="field">
        <label class="label">Synopsis</label>
        <quill-editor v-model="synopsis" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>

        <!-- rich text vue-quill-editor plugin -->
        <label class="label">Excerpt</label>
        <quill-editor v-model="excerpt" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">

        <!-- rich text vue-quill-editor plugin -->
        <div class="field">
        <label class="label">About Author</label>
        <quill-editor v-model="author_text" :options="editorOptions">
        </quill-editor>
        <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>

        <!-- Category field -->
        <!-- <br>
        <div class="field">
          <label class="label">Category</label>
          <div class="control">
            <input type="text" class="input" placeholder="Category" v-model="category" maxlength="25">
          </div>
        </div> -->

      </div>

      <!-- new post right sidebar -->
      <div class="column is-one-third">

        <div class="columns">
        <div class="column is-half">
        <!-- price -->
        <div class="field">
          <label class="label">Price Paper</label>
          <div class="control">
            <input type="text" class="input" placeholder="price for paper" v-model="price_paper" maxlength="25" required>
            <p></p>
          </div>
        </div>
        </div>
        <div class="column is-half">
        <div class="field">
          <label class="label">Price Ebook</label>
          <div class="control">
            <input type="text" class="input" placeholder="price for ebook" v-model="price_ebook" maxlength="25" required>
            <p></p>
          </div>
        </div>
      </div>
    </div>

        <div class="columns">
        <div class="column is-one-third">
        <!-- year -->
        <div class="field">
          <label class="label">Year</label>
          <div class="control">
            <input type="text" class="input" placeholder="year" v-model="year" maxlength="25" required>
            <p></p>
          </div>
        </div>
       </div>
       <div class="column is-one-third">
        <div class="field">
          <label class="label">Original Year</label>
          <div class="control">
            <input type="text" class="input" placeholder="original publishing year" v-model="original_year" maxlength="25" required>
            <p></p>
          </div>
        </div>
       </div>
       </div>

        <!-- pages_words -->
        <div class="field">
          <label class="label">Pages</label>
          <div class="control">
            <input type="text" class="input" placeholder="pages" v-model="pages" maxlength="25" required>
            <p></p>
          </div>
        </div>

        <!-- author -->
        <!-- <div class="field">
          <label class="label">Author</label>
          <div class="control">
            <input type="text" class="input" placeholder="Author" v-model="author" maxlength="25" required>
            <p></p>
          </div>
        </div> -->

        <!-- editor -->
        <div class="field">
          <label class="label">Editor</label>
          <div class="control">
            <input type="text" class="input" placeholder="Editor" v-model="editor" maxlength="25" required>
            <p></p>
          </div>
        </div>

        <!-- authors -->
        <div class="field">
          <label class="label">Authors</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeAuthor(index)" v-for="(aut, index) in authors" :key="index" class="tag is-info pointer">{{aut}}<button class="delete is-small"></button></span>
            <input placeholder="Authors" @keypress.44.prevent="styleAuthors" @keyup.enter="styleAuthors" type="text" class="input" maxlength="25" v-model="inputDataAuthors">
            </div>
            <p>Separate authors with ENTER</p>
          </div>
        </div>

        <!-- categories -->
        <div class="field">
          <label class="label">Categories</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeCategory(index)" v-for="(cat, index) in categories" :key="index" class="tag is-info pointer">{{cat}}<button class="delete is-small"></button></span>
            <input placeholder="Categories" @keypress.44.prevent="styleCategories" @keyup.enter="styleCategories" type="text" class="input" maxlength="25" v-model="inputDataCategories">
            </div>
            <p>Separate Categories with ENTER</p>
          </div>
        </div>

        <!-- tags -->
        <!-- <div class="field">
          <label class="label">Tags</label>
          <div class="control">
            <div class="tags tagscontainer">
            <span @click="removeTag(index)" v-for="(tag, index) in tags" :key="index" class="tag is-info pointer">{{tag}}<button class="delete is-small"></button></span>
            <input placeholder="Tags" @keypress.44.prevent="styleTags" @keyup.enter="styleTags" type="text" class="input" maxlength="25" v-model="inputData">
            </div>
            <p>Seperate tags with commas</p>
          </div>
        </div> -->

        <div class="field">
          <label class="label">Cover (100x100px)</label>
          <div class="control">
            <img :src="cover">
            <div class="file">
              <label class="file-label">
                <input @change="uploadFeaturedImage" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">PDF</label>
          <div class="control">
            <a v-if="file_pdf" :href="file_pdf">file</a>
            <div class="file">
              <label class="file-label">
                <input @change="uploadPDF" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">EPub</label>
          <div class="control">
            <a v-if="file_epub" :href="file_epub">file</a>
            <div class="file">
              <label class="file-label">
                <input @change="uploadEpub" class="file-input" type="file" name="resume">
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>

      </div> <!-- Right Sidebar -->
    </div>

    <!-- notification -->
    <div v-if="notification.message" :class="'notification is-' + notification.type">
      <button class="delete" @click="hideNotifications"></button>{{notification.message}}
    </div>

    <!-- the form buttons -->
    <button type="submit" class="button is-success" @click="add('published')">Publish</button>
    <button type="submit" class="button is-info" @click="add('saved')">Save Draft</button>
    <router-link to="/admin/books" class="button is-danger">Cancel</router-link>
  </div>
</template>

<script>
import firebase from 'firebase'

import { mediaRef } from '@/firebase_config'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'
import notifier from '@/mixins/notifier'

export default {
  name: 'post-new',
  data () {
    return {
      title: '',
      synopsis: '',
      excerpt: '',
      pages: '',
      year: '',
      original_year: '',
      price_paper: '',
      price_ebook: '',
      author: '',
      author_text: '',
      editor: '',
      authors: [],
      categories: [],
      tags: [],
      cover: '',
      file_epub: '',
      file_pdf: '',
      category: '',
      editorOptions
    }
  },
  firebase: {
    media: mediaRef
  },
  props: ['add-post'],
  mixins: [imageLoader, notifier],
  methods: {
    add (state) {
      if (this.title) {
        this.addPost({
          title: this.title.trim(),
          synopsis: this.synopsis,
          excerpt: this.excerpt,
          author: this.author.trim(),
          pages: this.pages,
          year: this.year,
          original_year: this.original_year,
          price_paper: this.price_paper,
          price_ebook: this.price_ebook,
          author_text: this.author_text,
          editor: this.editor.trim(),
          tags: this.tags,
          authors: this.authors,
          categories: this.categories,
          file_pdf: this.file_pdf,
          file_epub: this.file_epub,
          cover: this.cover,
          category: this.category.trim(),
          created: Date.now(),
          selected: false,
          state: state
        })
        this.$router.push({ path: '/admin/books' })
      } else {
        this.showNotification('warning', 'The title field can not be empty')
      }
    },
    uploadFeaturedImage (e) {
      console.log('upload')
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.cover = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    uploadPDF (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('ebooks/pdf/' + file.name)
      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.file_pdf = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    uploadEpub (e) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('ebooks/epub/' + file.name)
      console.log('uploadEpub')
      storageRef.put(file).then((snapshot) => {
        this.file_epub = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    styleAuthors () {
      if (this.inputDataAuthors !== '') {
        this.authors.push(`${this.inputDataAuthors.trim()}`)
        this.inputDataAuthors = ''
      }
    },
    removeAuthor (index) {
      this.authors.splice(index, 1)
    },
    styleCategories () {
      if (this.inputDataCategories !== '') {
        this.categories.push(`${this.inputDataCategories.trim()}`)
        this.inputDataCategories = ''
      }
    },
    removeCategory (index) {
      this.categories.splice(index, 1)
    },
    styleTags () {
      if (this.inputData !== '') {
        this.tags.push(`${this.inputData.trim()}`)
        this.inputData = ''
      }
    },
    removeTag (index) {
      this.tags.splice(index, 1)
    }
  }
}

</script>

<style>
.tagscontainer {
  border: 2px solid #f2f2f2;
  border-radius: 5px;
  padding: 5px;
}
.pointer {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/content/BookNew.vue